var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistanceLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49984 1.5835C6.0165 1.5835 3.1665 4.4335 3.1665 7.91683C3.1665 12.1918 8.70817 17.021 8.94567 17.2585C9.104 17.3377 9.3415 17.4168 9.49984 17.4168C9.65817 17.4168 9.89567 17.3377 10.054 17.2585C10.2915 17.021 15.8332 12.1918 15.8332 7.91683C15.8332 4.4335 12.9832 1.5835 9.49984 1.5835ZM9.49984 15.596C7.83734 14.0127 4.74984 10.6085 4.74984 7.91683C4.74984 5.30433 6.88734 3.16683 9.49984 3.16683C12.1123 3.16683 14.2498 5.30433 14.2498 7.91683C14.2498 10.5293 11.1623 14.0127 9.49984 15.596ZM9.49984 4.75016C7.75817 4.75016 6.33317 6.17516 6.33317 7.91683C6.33317 9.6585 7.75817 11.0835 9.49984 11.0835C11.2415 11.0835 12.6665 9.6585 12.6665 7.91683C12.6665 6.17516 11.2415 4.75016 9.49984 4.75016ZM9.49984 9.50016C8.629 9.50016 7.9165 8.78766 7.9165 7.91683C7.9165 7.046 8.629 6.3335 9.49984 6.3335C10.3707 6.3335 11.0832 7.046 11.0832 7.91683C11.0832 8.78766 10.3707 9.50016 9.49984 9.50016Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceLocation);
export default __webpack_public_path__ + "static/media/distanceLocation.5e32e45d07cc7e5e91de551574278f3f.svg";
export { ForwardRef as ReactComponent };